PJQ.views.budget.AddBudgetLineItemForecastModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-add-forecast'),
		subTemplates: {
			lineItems: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'add-forecast-line-item')
		},
		maxWidth: 900,
		isShowCloseButton: true,
		onSave: _.noop,
		canEdit: true,
		isAdmin: true
	},
	events: {
		'keyup .input-quantity, .input-unit-price': 'calculateUnitTotal',
		'click .btn-add-line-item': 'addLineItem',
		'click .btn-delete-line-item': 'deleteLineItem',
		'click .btn-save': 'save',
		'click .btn-cancel': 'cancel',
		'click .btn-switch-method': 'switchMethod'
	},
	beforeModalCreated: function () {
		this.options.canEdit = PJQ.app.session.project.hasPermission('budget.canEdit');
		this.options.isAdmin = PJQ.app.session.project.hasPermission('budget.isAdmin');

		this.model.fetch({
			success: _.bind(function(){
				PJQ.app.session.project.fetchCostTypes(_.bind(function (costTypes) {
					this.costTypes = costTypes;
					PJQ.app.session.project.fetchUnitsOfMeasure(_.bind(function (unitsOfMeasure) {
						this.unitsOfMeasure = unitsOfMeasure
						this.collection = new PJQ.collections.budget.ForecastLineItems(this.model.get('forecastLineItems'));
						this.render();
					}, this));
				}, this));
			}, this)
		})

	},
	renderData: function () {
		return {
			collection: this.collection,
			costTypes: this.costTypes != null ? this.costTypes.models : [],
			unitsOfMeasure: this.unitsOfMeasure != null ? this.unitsOfMeasure.models : [],
			accountingMethod: this.accountingMethod,
			model: this.model,
			canEdit: this.options.canEdit,
			isAdmin: this.options.isAdmin
		}
	},
	afterRender: function () {
		this.unitOfMeasureSelector = new PJQ.inputs.Selectpicker({
			el: this.$('.select-unit-of-measure'),
			defaultValue: this.unitsOfMeasure != null && _.size(this.unitsOfMeasure.models) > 0 ? this.unitsOfMeasure.models[0].id : null,
			onChange: _.bind(function (value) {
				this.validateForm();
			}, this),
			isIntChoices: true,
			hideDisabled: true
		});

		PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);

		this.renderLineItems();
	},
	validateForm: function () {
		let quantity = this.$('.input-quantity').val(),
			unitPrice = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-unit-price')),
			valid = quantity > 0 && unitPrice > 0;
		this.$('.btn-add-line-item').prop('disabled', !valid);
	},
	calculateUnitTotal: function () {
		let quantity = parseInt(this.$('.input-quantity').val()),
			unitPrice = PJQ.helpers.formatHelpers.numbersOnly(this.$('.input-unit-price').val(), false, true);
		this.$('.unit-total').html(PJQ.helpers.formatHelpers.formatCurrency(quantity * unitPrice));
		this.validateForm();
	},
	setAccountingMethod: function (method) {
		this.accountingMethod = method;

		let $manual = this.$('.method-manual'),
			$calculated = this.$('.method-calculated');
		if (this.accountingMethod === 0) {
			$manual.removeClass('hidden');
			$calculated.addClass('hidden');
		}
		else if (this.accountingMethod === 1) {
			$manual.addClass('hidden');
			$calculated.removeClass('hidden');
		}
	},
	resetAddForm: function () {
		this.$('.input-budgeted-cost').val('');
		this.$('.description').val('');
		this.$('.input-unit-price').val('');
		this.$('.input-quantity').val('');
		this.validateForm();
	},
	deleteLineItem: function (e) {
		let $target = $(e.currentTarget).closest('.line-item'),
			cid = $target.data('cid'),
			item = this.collection.get(cid);

		item.set('delete', true);
		$target.closest('.line-item').remove();
		this.calculateSubTotal();
	},
	addLineItem: function () {
		let newLineItem = new PJQ.models.budget.ForecastLineItem({
			budgetId: this.options.budget.id,
			accountingMethod: this.accountingMethod
		});
			let quantity = this.$('.input-quantity').val(),
				unitPrice = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-unit-price')),
				description = this.$('.description').val();
			newLineItem.set({
				unitId: this.unitOfMeasureSelector.getValue(),
				quantity: _.size(quantity) > 0 ? parseInt(quantity) : 0,
				unitPrice: unitPrice != null ? unitPrice : 0,
				description: description
			})

		this.$('.alert').prop('hidden', true);
		this.model.set('forecastMethod', 1);
		this.collection.add(newLineItem);
		this.renderLineItems();
		this.resetAddForm();
	},
	renderLineItems: function ($el, lineItem) {
		if(this.collection) {
			this.$('.no-items').addClass('hidden');
			this.renderSubTemplate(false, this.options.subTemplates.lineItems, this.$('.line-items'), {
				lineItems: this.collection.models,
				groups: this.groups,
				costTypes: this.costTypes,
				unitsOfMeasure: this.unitsOfMeasure
			}, _.bind(function (el) {
			}, this));

			this.calculateSubTotal();
		}
	},
	calculateSubTotal: function() {
		let subtotal = 0;
		_.each(this.collection.models, function (item) {
			subtotal += item.get('quantity') * item.get('unitPrice')
		}, this)
		this.$('.subtotal').html(PJQ.helpers.formatHelpers.formatCurrency(subtotal));
	},
	switchMethod: function() {
		if(this.model.get('forecastMethod') === 1) {
			new PJQ.views.modals.YesNo({
				header: "Set to Automatic Calculation?",
				body: "Forecast to Complete will no longer be manually calculated, however any existing line items will still be saved. Would you like to continue?",
				onYes: _.bind(function () {
					this.model.set('forecastMethod', 0);
					this.render();
				}, this)
			});
		}
		else{
			new PJQ.views.modals.YesNo({
				header: "Switch to Manual Calculation?",
				body: "Forecast to Complete will no longer be automatically calculated. Would you like to continue?",
				onYes: _.bind(function () {
					this.model.set('forecastMethod', 1);
					this.render();
				}, this)
			});
		}
	},
	save: function () {
		this.model.set('forecastLineItems', this.collection.toJSON());

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'budgets',
					value: this.options.budget.id
				},
				{
					endpoint: 'lineitems',
					value: this.model.id
				},
				{
					endpoint: 'forecast'
				}
			]),
			isAPIv2: true,
			data: this.model
		}).put().done(_.bind(function (data) {
			PJQ.notifications.notify.successNotify({
				message: 'Forecast Successfully Changed'
			});
			if(typeof this.options.onSave === 'function'){
				this.options.onSave(false);
			}
			this.removeModal();
		}, this)).fail(function() {
			PJQ.notifications.notify.errorNotify({
				message: 'Failed to modify Forecast'
			});
			if(typeof this.options.onSave === 'function'){
				this.options.onSave(false);
			}
		});
	},
	cancel: function () {
		if(this.model.hasChanged()){
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.save();
				}, this),
				onDontSave: _.bind(function () {
					this.model.restore();
					this.removeModal();
				}, this)
			});
		}
		else{
			this.removeModal();
		}
	}
});
